import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Haus, Huia, W3HAUS, Brooke, Gauge, Inspiring, Infinit e Ecglobal",
    correct: true,
  },
  {
    option: "b) Haus, W3HAUS, Brooke, Gauge, Inspiring, Infinit e Ecglobal",
    correct: false,
  },
  {
    option: "c) Haus, W3HAUS, Brooke, Gauge, Infinit e Ecglobal",
    correct: false,
  },
  {
    option: "d) Haus, W3HAUS, Brooke, Inspiring, Infinit e Ecglobal",
    correct: false,
  },
  {
    option: "e) Haus, W3HAUS, Brooke, Gauge, Inspiring e Ecglobal",
    correct: false,
  },
];

export default function Question2(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question2: {
          title:
            "Quais são as empresas de Marketing que fazem parte do Grupo Stefanini ?",
          option: option.option,
          correct: option.correct,
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quais são as empresas de Marketing que fazem parte do Grupo Stefanini ?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
